const React = require("react");
const T = React.PropTypes;

const NexusData = require("../../types/metadata/NexusData.js");
const NexusDataActionCreators = require("../../actionCreators/metadata/NexusDataActionCreators.js");

const HttpResponse = require("../HttpResponse.jsx");
const Spinner = require("../Spinner.jsx");

const styles = {
    Question: {
        marginRight: 15
    },
    Choices: {

    }
};

const NexusForm = React.createClass({
    propTypes: NexusData.Type.isRequired,
    componentDidMount() {
        if (!this.props.Targets.Loaded) {
            NexusDataActionCreators.LoadTargets();
        }
    },
    render() {
        const isLoading = this.props.Targets.Loading;
        const error = this.props.Targets.Error;

        const hasError = error !== null;

        const selectedGLCode = this.props.Target ? this.props.Target.GLCode : "";

        if (hasError) {
            return (
                <div>
                    <h4>Account loading failed.</h4>
                    <h5>
                        Please give it another try by reloading the page.  If you continue to get this error, kindly contact support with the message below.
                    </h5>
                    <HttpResponse Response={error.response} />
                </div>);
        }

        if (isLoading
            || !this.props.Targets.Data.length) {
            return (<div>
                <Spinner style={{ padding: 0 }} Message="Loading eligible GL accounts..." WithTimer={true} Large={true} />
            </div>);
        }
        
        const choices = this.props.Targets.Data.map((target) => {
            return (<option key={target.GLCode} value={target.GLCode}>
                {`${target.Description} ${target.GLCode ? `(${target.GLCode})` : ""}`}
            </option>)
        });

        return (<div className="form-inline">
            <label htmlFor="pickTarget" style={styles.Question}>
                Where do you want to send the files?
            </label>
            <select id="pickTarget" className="form-control" style={styles.Choices}
                    value={selectedGLCode}
                    onChange={this.TargetChanged}>
                {choices}
            </select>
        </div>);
    },
    TargetChanged(e) {
        const target = this.props.Targets.Data
            .find((t) => t.GLCode === e.target.value);

        NexusDataActionCreators.SelectTarget(target);
    }
});

module.exports = NexusForm;


// WEBPACK FOOTER //
// ./src/components/metadata/NexusForm.jsx